import type { paths } from "@/api-schema";
import { optionsWithDefaults } from "@/common/api/_helpers/options-with-defaults";
import { Options } from "@/common/api/_types";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";

export const CASAVI_CONTACT_BLACKLIST_BY_UUID_RESOURCE = "casavi-contact-blacklist" as const;
export const CASAVI_CONTACT_BLACKLIST_BY_UUID_API_PATH =
  `/v1/${CASAVI_CONTACT_BLACKLIST_BY_UUID_RESOURCE}/{uuid}` as const;

export type CasaviContactBlacklistByUuidParameters =
  paths[typeof CASAVI_CONTACT_BLACKLIST_BY_UUID_API_PATH]["get"]["parameters"]["query"];
export type CasaviContactBlacklistByUuidResponse =
  paths[typeof CASAVI_CONTACT_BLACKLIST_BY_UUID_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useCasaviContactBlacklistByUuidQuery(
  uuid: string,
  options?: Options<CasaviContactBlacklistByUuidParameters, never>,
) {
  const optionsWithDefaultsResolved =
    optionsWithDefaults<Options<CasaviContactBlacklistByUuidParameters, never>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    enabled: !!uuid,
    queryKey: [CASAVI_CONTACT_BLACKLIST_BY_UUID_RESOURCE, uuid, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<CasaviContactBlacklistByUuidResponse>(
        `/v1/${CASAVI_CONTACT_BLACKLIST_BY_UUID_RESOURCE}/${uuid}`,
        {
          params: requestParameters,
        },
      );

      return response.data;
    },
  });
}
